<template>
  <div class="message">
    <el-alert class="mb20" title="下方为您所发布的项目列表展示，请慎重操作。" type="warning" show-icon>
    </el-alert>
    <div class="info_box">
      <div class="fliter">
        <div class="fliter_item">
          <el-button type="primary" icon="Plus" @click="addTransaction">新增项目</el-button>
        </div>
        <div class="fliter_item" style="width: 200px">
          <el-input v-model="paginationData.projectNo" placeholder="请输入项目编号" style="width: 200px" clearable>
          </el-input>
        </div>
        <div class="fliter_item" style="width: 200px">
          <el-input v-model="paginationData.projectName" placeholder="请输入项目名称" style="width: 200px" clearable>
          </el-input>
        </div>
        <div class="fliter_item" style="width: 200px">
          <el-select v-model="paginationData.status" filterable placeholder="请选择审核状态" style="width: 200px" clearable>
            <el-option v-for="item in statusList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
        <div class="fliter_item">
          <el-button type="primary" icon="Search" @click="searchData">检索</el-button>
        </div>
        <div class="fliter_item">
          <el-button plain icon="RefreshLeft" @click="resetData">重置</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe border v-loading="loading">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="userName" label="发布人"></el-table-column>
        <el-table-column prop="name" label="项目名称"></el-table-column>
        <el-table-column prop="no" label="项目编号"></el-table-column>
        <el-table-column prop="landArea" label="总面积（亩）"></el-table-column>
        <el-table-column prop="publishDate" label="发布时间"></el-table-column>
        <el-table-column prop="applyStartDate" label="报名开始时间"></el-table-column>
        <el-table-column prop="applyEndDate" label="报名结束时间"></el-table-column>
        <el-table-column prop="bidStartDate" label="竞价开始时间"></el-table-column>
        <el-table-column prop="bidEndDate" label="竞价结束时间"></el-table-column>

        <el-table-column label="审核状态" prop="status" :dateFormat="typeFormart">
          <template #default="scope">
            <el-tag v-if="scope.row.status == '1'" type="info">待审核</el-tag>
            <el-tag type="primary" v-if="scope.row.status == '2'">审核中</el-tag>
            <el-tag type="success" v-if="scope.row.status == '3'">审核通过</el-tag>
            <el-tag type="danger" v-if="scope.row.status == '4'">驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" fixed="right" width="200px">
          <template #default="scope">
            <el-link type="primary" @click="getDataDetail(scope.$index, scope.row)">查看详情</el-link>
            <el-divider direction="vertical" v-if="scope.row.status == '1' || scope.row.status == '4'"></el-divider>
            <el-link type="warning" v-if="scope.row.status == '1' || scope.row.status == '4'"
              @click="editDetail(scope.$index, scope.row)">编辑</el-link>

            <el-divider direction="vertical"></el-divider>
            <el-dropdown>
              <span class="el-dropdown-link">
                <el-icon>
                  <MoreFilled />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-if="scope.row.bidStatus == '4' || scope.row.bidStatus == '7'">
                    <!-- <el-link type="danger" @click="deleteAdministrators(scope.row)">删除</el-link> -->
                    <el-link type="primary" v-if="scope.row.bidStatus == '4' || scope.row.bidStatus == '7'"
                      @click="getReList(scope.$index, scope.row)">重新挂牌</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.bidStatus == '6' || scope.row.bidStatus == '4' ">
                    <el-link type="primary" @click="getContractDetail(scope.$index, scope.row)">查看合同</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item >
                    <el-link type="primary" @click="getAuditRecords(scope.$index, scope.row)">审核记录</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.bidStatus == '1'">
                    <el-link type="primary" @click="getProjectTerminate(scope.$index, scope.row)">终止项目</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.bidStatus == '6' || scope.row.bidStatus == '4'">
                    <el-link type="primary" @click="getTransferList(scope.$index, scope.row)">流转记录</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.status == '1' || scope.row.status == '4' || scope.row.bidStatus == '7'">
                    <el-link type="primary" @click="handleDeleteProject(scope.$index, scope.row)">删除</el-link>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap flex_end">
        <el-pagination background :current-page="paginationData.pageNum" :page-size.sync="paginationData.pageSize"
          @current-change="handleCurrentChange" layout="total, prev, pager, next"
          :total="paginationData.total"></el-pagination>
      </div>
    </div>

    <el-drawer v-model="contractPopup" title="合同详情" direction="rtl">
      <el-descriptions class="margin-top" :column="1" :size="size" border v-if="contractInfo.xhProjectFileList">
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              项目编号
            </div>
          </template>
          {{ contractInfo.projectNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              项目名称
            </div>
          </template>
          {{ contractInfo.projectName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同编号
            </div>
          </template>
          {{ contractInfo.contractNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同金额（元）
            </div>
          </template>
          {{ contractInfo.price }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同开始年限
            </div>
          </template>
          {{ contractInfo.startDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同结束年限
            </div>
          </template>
          {{ contractInfo.endDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同转出起始期限
            </div>
          </template>
          {{ contractInfo.contractStartDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同转出截止期限
            </div>
          </template>
          {{ contractInfo.contractEndDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              合同签订时间
            </div>
          </template>
          {{ contractInfo.contractDealDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              是否经过招投标
            </div>
          </template>
          <el-tag size="small" v-if="contractInfo.bidFlag == 'Y'">是</el-tag>
          <el-tag size="small" v-if="contractInfo.bidFlag == 'N'">否</el-tag>
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              备注
            </div>
          </template>
          {{ contractInfo.remark }}
        </el-descriptions-item>
        <div v-if="contractInfo.xhProjectFileList.length > 0">
          <el-descriptions-item>
            <template #label>
              <div class="cell-item">
                附件列表
              </div>
            </template>
            <el-link v-for="(item, index) in contractInfo.xhProjectFileList" :key="index" :href="item.filePath"
              target="_blank">{{ item.fileName }}, </el-link>
            <!-- {{ item.filePath }} -->
          </el-descriptions-item>
        </div>

      </el-descriptions>
    </el-drawer>

    <el-dialog v-model="AuditRecordsVisible" title="审核记录" width="50%">
      <el-table ref="AuditRecordsTable" :data="examinerList" stripe border>
        <el-table-column prop="id" label="编号" width="80"></el-table-column>
        <el-table-column prop="auditBy" label="审核人"></el-table-column>
        <el-table-column prop="auditTime" label="审核时间"></el-table-column>
        <el-table-column label="审核意见" prop="content">
        </el-table-column>
      </el-table>
      <div class="pagination-wrap flex_end">
        <el-pagination size="small" background :current-page="pageNum" page-size.sync="10"
          @current-change="handleAuditChange" layout=" prev, pager, next" :total="total"></el-pagination>
      </div>
    </el-dialog>

    <el-dialog v-model="circulationVisible" title="流转记录" width="50%">
      <el-table ref="circulationTable" :data="circulationList" stripe border>
        <el-table-column prop="inName" label="受让人名字"></el-table-column>
        <el-table-column prop="xhProjectDealInfo.startDate" label="合同开始时间"></el-table-column>
        <el-table-column prop="xhProjectDealInfo.endDate" label="合同结束时间"></el-table-column>
        <el-table-column label="合同附件" prop="content">
          <template #default="scope">
            <el-link v-for="(item, index) in scope.row.xhProjectFileList" :key="index" :href="item.filePath"
              target="_blank">{{ item.fileName }}, </el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="pagination-wrap flex_end">
        <el-pagination size="small" background :current-page="pageNum" page-size.sync="10"
          @current-change="handleAuditChange" layout=" prev, pager, next" :total="total"></el-pagination>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { projectList, getDict, contractDetail, recordList, terminateProject, deleteProject, transferList } from "@/utils/api";
var moment = require("moment");
export default {
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      singleCaseList: [],
      statusList: [],
      paginationData: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        projectNo: "",
        projectName: "",
        createBy: localStorage.userId,
        projectType: 1,
        status: "",
      },
      now_id: 0,
      contractPopup: false,
      contractInfo: {},
      AuditRecordsVisible: false,
      examinerList: [],
      pageNum: 1,
      total: 0,
      projectId: 0,

      circulationVisible: false,
      circulationList: [],
    };
  },
  computed: {},
  mounted() {
    this.getData();
    this.getAuditstatusDict();
  },
  methods: {
    // 竞价状态字典
    async getAuditstatusDict() {
      let res = await getDict({ dictType: 'audit_status' });
      this.statusList = res.data
    },
    // 新增项目
    addTransaction() {
      this.$router.push({
        path: "/addTransaction",
        query: {
          projectType: 1
        },
      });
    },

    // 编辑项目
    editDetail(index, row) {
      this.$router.push({
        path: "/addTransaction",
        query: {
          id: row.id,
        },
      });
    },

    // 查看详情
    getDataDetail(index, row) {
      this.$router.push({
        path: "/addTransaction",
        query: {
          id: row.id,
          isLook: 1,
        },
      });
    },
    // 重新挂牌
    getReList(index, row) {
      this.$router.push({
        path: "/addTransaction",
        query: {
          id: row.id,
          isListing: 1,
          projectType: 1
        },
      });
    },
    // 查看合同
    async getContractDetail(index, row) {
      let res = await contractDetail({ projectId: row.id });
      if (res.data) {
        this.contractInfo = res.data
        this.contractPopup = true;
      } else {
        this.$message.warning("暂无合同信息");
      }
    },
    // 终止项目
    async getProjectTerminate(index, row) {
      let res = await terminateProject({ projectId: row.id });
      if (res.code == 200) {
        this.$message.success("终止成功!");
        this.getData();
      } else {
        this.$message.warning(res.msg);
      }
    },
    async handleDeleteProject(index, row) {
      // 使用 MessageBox 进行确认提示
      this.$confirm(`是否确认删除该项目: ${row.name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // 用户确认删除
          let res = await deleteProject({ id: row.id });
          if (res.code == 200) {
            this.$message.success("删除成功!");
            this.getData(); // 刷新数据
          } else {
            this.$message.warning("删除失败,该项目已被删除或不存在，请刷新页面后重试");
          }
        })
        .catch(() => {
          // 用户取消删除
          this.$message.info("已取消删除");
        });
    },
    // 打开审核记录弹窗
    async getAuditRecords(index, row) {
      this.projectId = row.id;
      this.pageNum = 1;
      this.getRecordList();
    },
    // 获取审核记录
    async getRecordList() {
      let res = await recordList({ projectId: this.projectId, type: 2, pageNum: this.pageNum, pageSize: 10 });
      if (res.code == 200) {
        this.examinerList = res.rows
        this.AuditRecordsVisible = true;
        this.total = res.total;
      } else {
        // this.$message.warning("暂无合同信息");
      }
    },
    // 流转记录
    async getTransferList(index, row) {
      let res = await transferList({ projectId: row.id, projectType: 1 });
      if (res.code == 200) {
        this.circulationList = res.data
        this.circulationVisible = true;
      } else {
        // this.$message.warning("暂无合同信息");
      }
    },
    handleAuditChange(pageNum) {
      this.pageNum = pageNum;
      this.getRecordList();
    },
    // 删除管理员
    deleteAdministrators(row) {
      this.$confirm("确认删除本条数据！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.templateId = row.id;
          this.deleteAdmin(row);
        })
        .catch(() => {
          return this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    async deleteAdmin(row) {
      let res = await this.$http.get("/user/delcomad", {
        token: localStorage.token,
        admin_id: row.id,
      });
      if (res.errcode == 200) {
        this.$message.success("删除成功!");
        this.paginationData.pageNum = 1;
        this.getData();
      } else {
        this.$message.error(res.errmsg);
      }
    },
    async searchData() {
      this.paginationData.pageNum = 1;
      this.getData();
    },
    resetData() {
      this.paginationData.projectNo = "";
      this.paginationData.projectName = "";
      this.paginationData.status = "";
      this.paginationData.pageNum = 1;
      this.getData();
    },
    async getData() {
      let res = await projectList(this.paginationData);
      if (res.code == 200) {
        this.loading = false;
        this.tableData = res.data.rows;
        this.paginationData.total = Number(res.data.total);
      }
    },
    handleCurrentChange(num) {
      this.paginationData.pageNum = num;
      this.getData();
    },
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    formatTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    async handleEdit(index, row) { },
    typeFormart(row, index) {
      for (var i = 0; i < this.statusList.length; i++) {
        if (this.statusList[i].id == row.coopid) {
          return this.statusList[i].name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail_box {
  padding: 25px;
}

.cert_img {
  margin-top: 25px;

  img {
    display: block;
    width: 100%;
  }
}

.el-dropdown {
  margin-top: 5px;
}

.el-dropdown-link {
  height: 100%;
  cursor: pointer;
  color: var(--el-color-primary);
  outline: unset;
}
</style>
